import { useQuery } from "react-query"
import { useLang } from "ufinet-web-functions"
import { fetchGET, fetchGET2 } from "utils/https/https"


const useQueryCatalogReasonRejection = () => {
  const lang = useLang()
  return useQuery(['useQueryCatalogReasonRejection', lang], async () => {

    try {
      const {data} = await fetchGET('Catalog/GetCatalog/Rejected-Authorization-Reason', {
        headers: { lang },
      })

      const newData = data?.map((item: {id: number, name: string}) => ({
        label: item.name,
        value: item.id,
      })) ?? []
      return newData
      
    } catch (error) {

      throw error
      
    }

    
    
  })
}

const useQueryCatalogReasonRejectionFilter = () => {
  const lang = useLang()
  return useQuery(['useQueryCatalogReasonRejectionFilter', lang], async () => {

    try {
      const {data} = await fetchGET('Catalog/GetCatalog/RejectedReason', {
        headers: { lang },
      })

      const newData = data?.map((item: {id: number, name: string}) => ({
        label: item.name,
        value: item.id,
      })) ?? []
      return newData
      
    } catch (error) {

      throw error
      
    }

    
    
  })
}


const useGetKamsApproved = (data: any) => {
  const username = data && data.username ? data.username : null


  return useQuery(['UseGetKamsApproved', username], async () => {
    try {
      const serchParms = new URLSearchParams();

      if (username) {
        serchParms.append('username', username)
      }

      const response = await fetchGET2(`Catalog/GetCatalog/User-Approved?&${serchParms.toString()}`)
      return response

    } catch (error) {
      throw error
    }

  },
  {
    enabled: data.view === 'approved'
  }
)
}

const useGetKamsPending = (data: any) => {
  const username = data && data.username ? data.username : null


  return useQuery(
    ['useGetKamsPending', username],
    async () => {
    try {
      const serchParms = new URLSearchParams();

      if (username) {
        serchParms.append('username', username)
      }

      const response = await fetchGET2(`Catalog/GetCatalog/User-Pending?&${serchParms.toString()}`)
      return response

    } catch (error) {
      throw error
    }
  },
  {
    enabled: data.view === 'pending'
  }
)
}

const useGetKamsRejected = (data: any) => {
  const username = data && data.username ? data.username : null


  return useQuery(['useGetKamsRejected', username], async () => {
    try {
      const serchParms = new URLSearchParams();

      if (username) {
        serchParms.append('username', username)
      }

      const response = await fetchGET2(`Catalog/GetCatalog/User-Rejected?&${serchParms.toString()}`)
      return response

    } catch (error) {
      throw error
    }
  },
  {
    enabled: data.view === 'rejected'
  }
)
}

const useGetClientType = () => {


  return useQuery(['useGetClientType'], async () => {
    try {

      const response = await fetchGET2(`Catalog/GetCatalog/ClientType`)
      const newData = response?.data?.map((item: {id: string, name: string}) => ({
        label: item.name,
        value: item.id,
      })) ?? []

      return newData
    } catch (error) {
      throw error
    }
  }
)
}



export const catalogQuery = {
  useQueryCatalogReasonRejection,
  useQueryCatalogReasonRejectionFilter,
  useGetKamsApproved,
  useGetKamsRejected,
  useGetKamsPending,
  useGetClientType,
}
